/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Artcraft_K_InstallerInputs */

const en_home_artcraft_k_installer = /** @type {(inputs: Home_Artcraft_K_InstallerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installer`)
};

/**
* | output |
* | --- |
* | "Installer" |
*
* @param {Home_Artcraft_K_InstallerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_artcraft_k_installer = /** @type {((inputs?: Home_Artcraft_K_InstallerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Artcraft_K_InstallerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_artcraft_k_installer(inputs)
});
export { home_artcraft_k_installer as "home.artcraft.k_installer" }